import React, { useContext, useEffect, useState, Fragment } from "react";
import TableSection from "components/sales/tableSection/tableSection";
import { BaseUrl } from "../../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../../components/sales/layout/layout";
import { toast } from "react-toastify";

const BusinessHeadList = ({
  match,
  caseListRequest,
  caseListResponse = [],
  carBrandRequest,
  caseStatusUpdateResponse = [],
  caseStatusUpdateRequest,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [id, setId] = useState("");
  const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] =
    useState(false);
  const [statusChangeInput, setStatusChangeInput] = useState({
    status: "",
    remark: "",
    id: "",
  });
  const [roleId, setRoleId] = useState();
  const [userId, setUserId] = useState();

  useEffect(() => {
    (async () => {
      let filter = "";
      // if(window.localStorage.apply_ucd_case_filter){
      //     filter = JSON.parse(window.localStorage.apply_ucd_case_filter)
      // }
      setRoleId(window.localStorage.getItem("fusion-role"));
      setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
      setIsLoading(true);
      await caseListRequest(null, 1, 'BUSINESS_HEAD_APPROVAL_REQUIRED');
      await carBrandRequest();
      setIsLoading(false);
    })();
  }, []);

  const headers = [
    "Unique ID",
    "Business Name",
    "Customer Fist Name",
    "Vehicle No",
    "Bank Name",
    "Loan Amount",
    "status",
    "Created At",
    "Created By",
    "Action",
  ];

  const onPageChange = async (val) => {
    setIsLoading(true);
    await caseListRequest(null, val.selected + 1, 'BUSINESS_HEAD_APPROVAL_REQUIRED');
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      caseListResponse &&
      caseListResponse?.data &&
      caseListResponse?.data?.resultSets &&
      caseListResponse?.data?.resultSets.length > 0
    ) {
      const tableData = [
        "id",
        "unique_id",
        "dealer_name",
        "customer_name",
        "vehicle_registration_number",
        "bank_name",
        "loan_required_amount",
        "status",
        "created_at",
        "created_user_name",
      ];
      const data = caseListResponse?.data?.resultSets.map((element) =>
        Object.assign(
          ...tableData.map((key) =>
            key === "unique_id"
              ? { [key]: element["id"] }
              : { [key]: element[key] }
          ),
          (element["status"] &&
            (element["status"].toLocaleLowerCase() === "payment rejected" ||
              element["status"].toLocaleUpperCase() === "DISBURSED" ||
              element["status"].toLocaleUpperCase() === "LOGGED_IN" ||
              element["status"].toLocaleUpperCase() === "APPROVED" ||
              element["status"].toLocaleUpperCase() === "REJECTED" ||
              element["status"].toLocaleUpperCase() === "CANCELLED")) ||
            element["status"] === "Request For Approval" ||
            element["status"] === "REQUEST_FOR_CASE_APPROVAL" ||
            element["status"] === "COMPLETE_PAYMENT_RELEASED"
            ? {
                Action: [
                //   { name: "View Details", link: `${baseUrl}/ucd/case-view` },
                  { name: "Accept Payout", link: `${baseUrl}/ucd/payout-details-for-business-head` }
                ],
              }
            : element["status"].toLocaleUpperCase() === "APPROVED" && {
                Action: [
                  parseInt(roleId) === 54
                    ? {
                        name: "Change Status",
                        link: `${baseUrl}/ucd/case-view`,
                      }
                    : "",
                  //
                  //  parseInt(roleId) === 54 ? {name: 'Change Status', link: "#"} : ""
                ],
              }
        )
      );
      if (data) {
        data && setListData(data);
      }
      setPageCount(
        Math.ceil(
          caseListResponse?.data?.total / caseListResponse?.data?.per_page
        )
      );
    }
  }, [caseListResponse]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    // await caseListRequest(1,filterData);
    setIsLoading(false);
    filterToggle();
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    if (parseInt(caseStatusUpdateResponse?.status) === 200) {
      toast.success(caseStatusUpdateResponse?.message);
      setChangeCarLoanStatusModalOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (caseStatusUpdateResponse?.status !== 200) {
      toast.error(caseStatusUpdateResponse?.message);
    }
  }, [caseStatusUpdateResponse]);

  return (
    <>
      <Layout
        title={"Payout Listing"}
        isLoading={isLoading}
        isGoback={true}
        // Buttons={headerBtns}
      >
        <TableSection
          data={listData}
          isId={false}
          isMngId={false}
          headers={headers}
          pageCount={pageCount}
          onPageChange={onPageChange}
          detailList={caseListResponse?.data?.resultSets}
          srNo={caseListResponse?.data?.from}
          setChangeCarLoanStatusModalOpen={setChangeCarLoanStatusModalOpen}
          carLoanId={setId}
        />
      </Layout>
    </>
  );
};

export default BusinessHeadList;
